import React from 'react';
export function SalesLetter() {
  return <div className="max-w-3xl mx-auto px-5 md:px-6 py-10 md:py-14" data-id="element-339">
      <p className="font-sans text-sm text-gray-500 mb-1" data-id="element-340">
        Desde el escritorio de quien ha vivido lo mismo que tú
      </p>
      <p className="font-sans font-bold text-dark mb-6 text-base" data-id="element-341">
        Re: La estimulación temprana no debería ser tan difícil...
      </p>

      <p className="font-serif text-xl font-bold text-primary-dark mb-5" data-id="element-342">
        Querido/a Mamá, Papá o Cuidador que lo da todo,
      </p>

      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-343">
        ¿Alguna vez...
      </p>

      {/* Pain Bullets */}
      <ul className="list-none p-0 my-5 mb-7" data-id="element-344">
        <li className="py-3 pl-10 relative text-lg border-b border-dashed border-border-light" data-id="element-345">
          <span className="absolute left-0 top-3 text-xl" data-id="element-346">😟</span>
          Has sentido que <strong data-id="element-347">no te alcanza el tiempo</strong> para
          estimular a tu hijo como realmente te gustaría?
        </li>
        <li className="py-3 pl-10 relative text-lg border-b border-dashed border-border-light" data-id="element-348">
          <span className="absolute left-0 top-3 text-xl" data-id="element-349">😟</span>
          Te has acostado pensando si estás{' '}
          <strong data-id="element-350">acompañando su desarrollo de forma adecuada</strong>... o si
          te estás quedando corto/a?
        </li>
        <li className="py-3 pl-10 relative text-lg border-b border-dashed border-border-light" data-id="element-351">
          <span className="absolute left-0 top-3 text-xl" data-id="element-352">😟</span>
          Has querido <strong data-id="element-353">reducir las pantallas</strong>, pero no sabes con
          qué reemplazarlas porque tu hijo ya se ha acostumbrado?
        </li>
        <li className="py-3 pl-10 relative text-lg border-b border-dashed border-border-light" data-id="element-354">
          <span className="absolute left-0 top-3 text-xl" data-id="element-355">😟</span>
          Te has sentido{' '}
          <strong data-id="element-356">abrumado/a por el exceso de información</strong> en internet,
          sin saber qué es correcto, qué es mito y por dónde empezar?
        </li>
        <li className="py-3 pl-10 relative text-lg" data-id="element-357">
          <span className="absolute left-0 top-3 text-xl" data-id="element-358">😟</span>
          Has buscado un <strong data-id="element-359">regalo útil y con propósito</strong> para un
          bebé o niño pequeño, que no termine acumulando polvo en un rincón?
        </li>
      </ul>

      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-360">
        Estos son exactamente los problemas que yo enfrenté cuando quise
        estimular a mis propios hijos...
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-361">
        ... y son los <strong data-id="element-362">mismos desafíos</strong> que cientos de padres,
        abuelos y educadores me siguen compartiendo cada día.
      </p>

      <p className="text-center my-8" data-id="element-363">
        <span className="font-handwritten text-3xl md:text-4xl text-primary-dark" data-id="element-364">
          "¡La estimulación temprana no debería ser tan complicada!"
        </span>
      </p>

      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-365">
        Ahora, si quieres darle a tu hijo el mejor comienzo posible —{' '}
        <strong data-id="element-366">de forma rápida, fácil y sin culpas</strong>...
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-367">
        En lugar de pasar horas, semanas o meses buscando información dispersa
        en internet o, peor aún, gastando una fortuna en profesionales que solo
        ves una hora a la semana...
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-368">
        Y anhelas la{' '}
        <strong data-id="element-369">tranquilidad de saber que estás haciendo las cosas bien</strong>
        , conectando de verdad con tu pequeño/a cada día...
      </p>
      <p className="font-serif text-lg text-body-text mb-8 leading-relaxed" data-id="element-370">
        Entonces esta puede ser la{' '}
        <strong data-id="element-371">carta más importante que leas en mucho tiempo</strong>...
      </p>

      <hr className="border-t-2 border-dashed border-border-light my-10" data-id="element-372" />

      {/* Enemy Section */}
      <div className="bg-[#FFF3F3] border-l-[5px] border-primary py-7 px-6 my-8 rounded-r-lg" data-id="element-373">
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-primary-dark mb-4 text-left" data-id="element-374">
          "Aquí Está El GRAN Problema..."
        </h2>

        <p className="font-serif text-lg text-body-text mb-4 leading-relaxed" data-id="element-375">
          Cuando empecé a buscar información sobre estimulación temprana en
          internet, comprando libros y probando lo que "recomiendan los gurús",
          descubrí algo preocupante:
        </p>
        <p className="font-serif text-xl font-bold text-body-text mb-4" data-id="element-376">
          La mayoría de los recursos y consejos que encuentras son BASURA
          COMPLETA.
        </p>
        <p className="font-serif text-lg text-body-text mb-4 leading-relaxed" data-id="element-377">
          Y aquí está el porqué:
        </p>

        <ul className="list-none p-0 mt-4" data-id="element-378">
          <li className="py-2 pl-8 relative text-base" data-id="element-379">
            <span className="absolute left-0 text-primary font-black text-lg" data-id="element-380">
              ✘
            </span>
            <strong data-id="element-381">Información genérica que NO es específica por edad</strong>{' '}
            — Te dicen "estimula a tu bebé", pero no te dicen QUÉ hacer
            exactamente en el mes 3, en el mes 7 o a los 2 años.
          </li>
          <li className="py-2 pl-8 relative text-base" data-id="element-382">
            <span className="absolute left-0 text-primary font-black text-lg" data-id="element-383">
              ✘
            </span>
            <strong data-id="element-384">
              Consejos que asumen que eres experta en desarrollo infantil
            </strong>{' '}
            — Usan términos técnicos y te dejan "rellenando los huecos" como si
            tuvieras un máster en neurociencia.
          </li>
          <li className="py-2 pl-8 relative text-base" data-id="element-385">
            <span className="absolute left-0 text-primary font-black text-lg" data-id="element-386">
              ✘
            </span>
            <strong data-id="element-387">Exigencias IRREALES que te roban la tranquilidad</strong> —
            Te hacen sentir que si no dedicas 2 horas diarias con materiales
            caros, estás "fallando" como madre o padre.
          </li>
          <li className="py-2 pl-8 relative text-base" data-id="element-388">
            <span className="absolute left-0 text-primary font-black text-lg" data-id="element-389">
              ✘
            </span>
            <strong data-id="element-390">
              Actividades que requieren materiales costosos o imposibles de
              conseguir
            </strong>{' '}
            — Como si todos tuviéramos un aula Montessori en casa.
          </li>
          <li className="py-2 pl-8 relative text-base" data-id="element-391">
            <span className="absolute left-0 text-primary font-black text-lg" data-id="element-392">
              ✘
            </span>
            <strong data-id="element-393">
              Y en la mayoría de los casos, simplemente NO HAY SUFICIENTE
              DETALLE
            </strong>{' '}
            — Un párrafo vago, una foto bonita de Pinterest, y "buena suerte".
          </li>
        </ul>
      </div>

      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-394">
        Vi una cuenta de Instagram que prometía "actividades fáciles para bebés"
        pero las instrucciones eran tan ambiguas que no sabías si era para un
        recién nacido o para un niño de 3 años.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-395">
        Otra "guía" que descargué de un blog tenía ejercicios que{' '}
        <strong data-id="element-396">NO eran apropiados para la edad indicada</strong> — lo cual,
        lejos de ayudar, puede generar frustración en el niño y en ti.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-397">
        Estos supuestos recursos "paso a paso" hacen que la estimulación
        temprana parezca <strong data-id="element-398">MÁS DIFÍCIL</strong> de lo que realmente es.
      </p>
      <p className="font-serif text-lg text-body-text font-bold mb-8 leading-relaxed" data-id="element-399">
        ¡Con razón tantos padres se sienten perdidos!
      </p>

      <hr className="border-t-2 border-dashed border-border-light my-10" data-id="element-400" />

      {/* Solution Section */}
      <h2 className="font-serif text-2xl md:text-3xl font-bold text-dark text-center mb-5" data-id="element-401">
        "Así Que Decidí Resolver Todo Eso..."
      </h2>

      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-402">
        Bueno, por suerte para ti, todos esos problemas se convirtieron en una
        bendición disfrazada.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-403">
        Porque he dedicado años a recopilar, diseñar y organizar la colección
        más completa de actividades de estimulación temprana en español,{' '}
        <strong data-id="element-404">mes a mes, área por área</strong>.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-405">
        Estas guías únicas están diseñadas por profesionales y especialistas en
        desarrollo infantil, y{' '}
        <strong data-id="element-406">NO las encontrarás en ningún otro lugar</strong>.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-407">
        Así que, ¿qué dirías si pudieras tener acceso a{' '}
        <strong data-id="element-408">más de 1.000 actividades planeadas</strong>...
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-409">
        ...con instrucciones <strong data-id="element-410">"ya hechas para ti"</strong> que incluyen
        el paso a paso, la edad exacta, los materiales que ya tienes en casa y
        el área de desarrollo que estimulan...
      </p>
      <p className="font-serif text-lg text-body-text mb-8 leading-relaxed" data-id="element-411">
        Para que puedas{' '}
        <span className="highlight" data-id="element-412">
          conectar con tu hijo/a, estimular su mente y su cuerpo — fácilmente,
          en pocos minutos y sin complicaciones?
        </span>
      </p>

      {/* Product Intro Box */}
      <div className="bg-gradient-to-br from-[#E8F5E9] to-light-bg py-10 px-7 rounded-xl text-center my-10 border-2 border-[#C8E6C9]" data-id="element-413">
        <p className="text-base text-gray-500 mb-1" data-id="element-414">Presentamos...</p>
        <p className="font-sans text-3xl md:text-4xl font-black text-green-dark mb-2" data-id="element-415">
          Pack Estimulación Temprana
        </p>
        <p className="text-lg text-gray-600 italic mb-1" data-id="element-416">
          "La Guía Más Completa Para Los Primeros 5 Años de Vida"
        </p>
        <p className="font-sans text-4xl md:text-5xl font-black text-primary my-4" data-id="element-417">
          +1.000 Actividades
        </p>
        <p className="text-lg text-gray-700" data-id="element-418">
          Organizadas mes a mes · Sin pantallas · Desde casa
          <br data-id="element-419" />
          <strong data-id="element-420">...incluso si solo tienes 10 minutos al día!</strong>
        </p>
      </div>
    </div>;
}